import React, { createContext, useState, useEffect } from "react";
import * as signalR from "@microsoft/signalr";
import PropTypes from "prop-types";
import { fetchNotifications } from "../../Redux/Slice/Notifications/GetNotification";
import { useDispatch } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import { useNavigate } from "react-router-dom";
import { useSession } from "../SessionContext";

const SignalRContext = createContext(null);
const baseUrl =
  process.env.REACT_APP_API_URL_TYPE === "test"
    ? process.env.REACT_APP_API_URL_TEST
    : process.env.REACT_APP_API_URL_TYPE === "ngrok"
    ? process.env.REACT_APP_API_URL_NGROK
    : process.env.REACT_APP_API_URL_LOCAL;

export const SignalRProvider = props => {
  const [connection, setConnection] = useState(null);
  const [realNotification, setRealNotification] = useState([]);
  const dispatch = useDispatch();
  const [Token, setToken] = useState(sessionStorage.getItem("access_token"));
  const navigate = useNavigate();

  const { session } = useSession();
  useEffect(() => {
    if (Token) {
      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${baseUrl}notificationHub`, {
          // transport: signalR.HttpTransportType.WebSockets,
          accessTokenFactory: () => {
            // Retrieve the JWT token from localStorage or another source
            return sessionStorage.getItem("access_token");
          },
        })
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Debug)
        .build();

      setConnection(newConnection);
    }
    // else {
    //   console.log("[SignalR] Token is not available. Cannot establish connection.");
    // }
  }, [Token]);

  useEffect(() => {
    if (connection) {
      // Handler for notifications
      connection.on("ReceiveNotification", data => {
        try {
          // console.log("[SignalR] Received notification data:", data);
          // setRealNotification(prev => [...prev, data]);

          if (data?.referanceType === "Activity" && location.pathname === "/activities") {
            // Page reload
            window.location.reload();
          }

          dispatch(fetchNotifications({ LoginId: session.LoginId, PageNumber: 1, PageSize: 10 }));

          const messageText =
            data?.NotificationText ||
            data?.notificationText ||
            data?.Notification?.NotificationText ||
            data?.message ||
            data?.Message ||
            "New notification received!";

          const formattedMessage = messageText
            .replace(/LeadRemarks/i, "Lead Remarks")
            .replace(/Lead Remarks\s+(.*?)\s+Add by Admin/i, 'Lead Remarks "$1" Add by Admin');

          const handleToastClick = t => {
            const leadId = data?.notificationId;
            toast.dismiss(t.id);
            navigate("/leads/view", { state: { id: leadId, type: "Notification" } });
          };

          toast.custom(
            t => (
              <div
                onClick={() => handleToastClick(t)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  background: "#D1ECEC",
                  color: "#282121",
                  padding: "12px 18px",
                  borderRadius: "10px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  fontSize: "14px",
                  fontWeight: 500,
                  minWidth: "320px",
                  cursor: "pointer",
                }}
              >
                <LeaderboardIcon style={{ color: "#298b8b", fontSize: "22px" }} />
                <span>{formattedMessage}</span>
              </div>
            ),
            {
              position: "top-center",
              duration: 15000,
            }
          );
        } catch (err) {
          console.error("[SignalR] Error processing notification data:", err);
        }
      });

      // Log connection state changes
      connection.onclose(error => {
        console.error("[SignalR] Connection closed:", error);
      });

      connection.onreconnecting(error => {
        console.warn("[SignalR] Connection reconnecting. Error:", error);
      });

      connection.onreconnected(() => {});

      // connection.onreconnected(connectionId => {
      //   console.log("[SignalR] Connection reconnected. New connectionId:", connectionId);
      // });

      connection
        .start()
        .then(() => {
          // console.log("[SignalR] Connection started successfully!");
        })
        .catch(err => {
          console.error("[SignalR] Connection failed to start:", err);
        });
      return () => {
        connection.off("ReceiveNotification");
      };
    }
  }, [connection]);
  // const removeNotification = () => {
  //   setRealNotification((prevNotifications) => prevNotifications.slice(1));
  // };
  const removeNotification = notificationId => {
    setRealNotification(prevNotifications =>
      prevNotifications.filter(notification => notification.notificationId !== notificationId)
    );
  };

  return (
    <SignalRContext.Provider value={{ realNotification, removeNotification, connection, setToken }}>
      {props.children}
      <Toaster />
    </SignalRContext.Provider>
  );
};

SignalRProvider.propTypes = {
  children: PropTypes.any,
};

export default SignalRContext;
